package app.nestbridge.domain.ping.usecase

import com.karawek.core.network.AuthMode
import app.nestbridge.domain.ping.service.PingService
import me.tatarka.inject.annotations.Inject

@Inject
class PingUseCase(
    private val pingService: PingService,
) {
    suspend operator fun invoke(authMode: AuthMode): Map<String, String> = pingService.ping(authMode)
}
